<template>
    <BorrarModalComponent
        :name="'borrar-' + evento.id"
        title="¿Seguro que quieres borrar este evento?"
        borrarTitle="Datos del evento"
        confirmButton="¿BORRAR EVENTO?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarEvento()"
    >
        <ul class="list-group list-group-unbordered mb-3">
            <li class="list-group-item">
                <b>Nombre:</b> {{ evento.nombre_completo }}
            </li>
        </ul>
    </BorrarModalComponent>
</template>

<script>
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

    export default {
        props: ['evento'],
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.evento.id, borrado);
            },
            borrarEvento() {
                const params = {
                    filters : {},
                    evento_id: this.evento.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                });
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
